import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link, useParams } from "react-router-dom";
import Page from "../../Page";
import ConversationSection from "./ConversationSection";

export default function FinanceProceed() {
  const { id } = useParams();
  return (
    <>
      <Page title="Loan Offers">
        <div className="myaccount-content">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h4>Loan Discussion</h4>
            </div>
            <div>
              <Link
                to="/financer/loan-offers"
                className="text-primary fs-18 fw-500"
              >
                <i className="far fa-arrow-alt-circle-left"></i> Back
              </Link>
            </div>
          </div>
        </div>
        <ConversationSection loanId={id} />
      </Page>
    </>
  );
}
